import { ACTIONS } from '../constants';

export const resetPages = () => {
  return { type: ACTIONS.RESET_PAGES };
};

export const updatePagesDisabled = (disabled) => {
  return { payload: disabled, type: ACTIONS.UPDATE_PAGES_DISABLED };
};

export const updatePagesErrors = (errors) => {
  return { payload: errors, type: ACTIONS.UPDATE_PAGES_ERRORS };
};

export const updatePagesLoadings = (loadings) => {
  return { payload: loadings, type: ACTIONS.UPDATE_PAGES_LOADINGS };
};

export const updatePagesPatching = (patching) => {
  return { payload: patching, type: ACTIONS.UPDATE_PAGES_PATCHING };
};

export const updatePagesWarnings = (warnings) => {
  return { payload: warnings, type: ACTIONS.UPDATE_PAGES_WARNINGS };
};
